'use client';

import NavItem from '@components/nav-item';
import {
  SidebarGroup,
  SidebarGroupLabel,
  SidebarMenu
} from '@components/ui/sidebar';
import { getRouteItems, ROUTE } from '@utils/route-utils';
import { useTranslations } from 'next-intl';

type NavMainProps = {
  organization_id: string;
};

export function NavMain({ organization_id }: NavMainProps) {
  const t = useTranslations();
  const routeItems = getRouteItems(organization_id, t);
  const shift = routeItems[ROUTE.COMMUNICATION].children?.find(
    item => item.id === 'messages'
  );

  return (
    <SidebarGroup>
      <SidebarGroupLabel>{t('navigation.service')}</SidebarGroupLabel>
      <SidebarMenu>
        <NavItem item={routeItems[ROUTE.HOME]} />
        <NavItem item={routeItems[ROUTE.EIGHTY_SIX]} />
        {shift ? (
          <NavItem item={{ ...shift, label: t('navigation.shift') }} />
        ) : null}
      </SidebarMenu>
    </SidebarGroup>
  );
}
